import {InputProps, useInput} from '@/hooks/useInput';
import clsx from 'clsx';
import SelectMultiple, {SelectMultipleProps} from 'components/basic/SelectMultiple';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import {Label} from '@/shadcn_components/ui/label';

export type SelectMultipleInputProps = InputProps &
  SelectMultipleProps &
  Partial<React.ComponentProps<'div'>>;

const SelectMultipleInput = (props: SelectMultipleInputProps) => {
  const {field, fieldState} = useInput(props);
  const {className, choices, placeHolder, label, optionText,helperText} = props;

  return (
    <div className={clsx('w-full space-y-1', className)}>
      <Label>{props.label}</Label>
      <SelectMultiple
        {...field}
        choices={choices}
        placeHolder={placeHolder || String(label)}
        optionText={optionText}
      />
      <HelperText helperText={helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default SelectMultipleInput;
